import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

export const SolidButton = ({icon, title, size, color, spacing, ...props}) => {
    return <button {...props} className={`ldsrf-btn-solid color-${color} ${size ? `size-${size}`:''} ${spacing ? `spacing-${spacing}`:''}`}>{icon ? icon:null} {title ? title:null}</button>
}

export const FadeButton = ({icon, title, size, color, spacing, ...props}) => {
    return <button {...props} className={`ldsrf-btn-fade color-${color} ${size ? `size-${size}`:''} ${spacing ? `spacing-${spacing}`:''}`}>{icon ? icon:null} {title ? title:null}</button>
}

export const TransparentButton = ({icon, title, ...props}) => {
    return <button {...props} className="ldsrf-btn-transparent">{icon ? icon:null} {title ? title:null}</button>
}

export const ChangeIconButton = ({...props}) => {
    return <button {...props} className="ldsrf-change-icon-btn"><i class="fad fa-pen-alt"/></button>
}

export const ViewIconButton = ({...props}) => {
    return <button {...props} className="ldsrf-view-icon-btn"><i class="fas fa-eye"/></button>
}

export const DeleteIconButton = ({...props}) => {
    return <button {...props} className="ldsrf-delete-icon-btn"><i class="fad fa-trash-alt"/></button>
}

export const DownloadIconButton = ({...props}) => {
    return <button {...props} className="ldsrf-delete-icon-btn"><i class="fad fa-download"></i></button>
}

export const InfoTableButton = ({title, color, ...props}) => {
    return <button {...props}  className={`ldsrf-info-table-btn color-${color}`}>{title ? title:null}</button>
}

export const ActionTableButton = ({title, color, size, spacing, ...props}) => {
    return <button {...props}  className={`ldsrf-action-table-btn color-${color} ${spacing ? `size-${size}`:''} ${spacing ? `spacing-${spacing}`:''}`}>{title ? title:null}</button>
}

InfoTableButton.propTypes = {
    color: PropTypes.oneOf(['blue', 'green', 'red', 'purple'])
}